export const Reuse9141 = `
... on Form9141DatahubReuse {
    visaType

    requestorPocLastName
    requestorPocFirstName
    requestorPocMiddleName
    requestorPocJobTitle
    requestorPocAddr1
    requestorPocAddr2
    requestorPocCity
    requestorPocState
    requestorPocPostalCode
    requestorPocCountry
    requestorPocProvince
    requestorPocPhone
    requestorPocPhoneExt
    requestorPocFaxNumber
    requestorPocEmail

    empBusinessName
    empTradeName
    empAddr1
    empAddr2
    empCity
    empState
    empPostcode
    empCountry
    empProvince
    empPhone
    empPhoneext
    empFein
    empNaics
    empNaicsDesc

    attyRepresentType
    attyLastname
    attyFirstname
    attyMiddlename
    attyAddr1
    attyAddr2
    attyCity
    attyState
    attyPostcode
    attyCountry
    attyProvince
    attyPhone
    attyPhoneext
    attyEmail
    attyBizname
    attyFein

    coveredByAcwia
    acwiaHigherEdu
    acwiaAffiliated
    acwiaNonprofit
    acwiaStatusChange
    sportsLeague
    cba
    pre_dbaSca
    dbaSca
    dbaSurvey
    survey
    surveyName
    surveyPublicationDate

    jobTitle 
    jobDuties 
    superviseOtherEmp 
    supervisedSocs {
        supervisedSocCode
        supervisedSocTitle
    }

    primaryEducationLevel
    otherEducation
    major
    secondDiploma
    secondDiplomaMajor
    trainingRequired
    numberOfMonthsTraining
    nameRequiredTraining
    empExperienceRequired
    empExperienceMonths
    occupationRequired
    specialRequirements
    isSpecialRequirements
    isSpecReqLicenseCert
    specReqLicenseCert
    isSpecReqForeignLang
    specReqForeignLang
    isSpecReqResFellow
    specReqResFellow
    isSpecReqOther
    specReqOther

    altJobRequirement
    altEducationLevel
    altOtherEdu
    altMajor
    altTrainingReq
    altNumMonthsTraining
    altNameReqdTraining
    altEmpExperienceReqd
    altEmpExpNumMonths
    isAltSpecialReq
    isAltSpecReqLicenseCert
    altSpecReqLicenseCert
    isAltSpecReqForeignLang
    altSpecReqForeignLang
    isAltSpecReqResFellow
    altSpecReqResFellow
    isAltSpecReqOther
    altSpecReqOther

    suggestedSocCode 
    suggestedSocTitle 
    supervisorJobTitle 
    travelRequired 
    travelDetails

    primaryWorksiteAddr1
    primaryWorksiteAddr2
    primaryWorksiteCity
    primaryWorksiteCounty{
      value
      label
    }
    primaryWorksiteBlsArea

    primaryWorksiteState
    primaryWorksitePostalCode
    otherWorksiteLocation
    otherWorksites {
      worksiteCity
      worksiteState
      worksiteBlsArea {
        label
        value
        blsAreaId
      }
      worksiteBlsAreaId
      worksitePostalCode
      worksiteCountyOrBlsArea
      worksiteCountyTownship{
        label
        value
        bls
        blsAreaId
      }
      error
    }
  }
`;
